import { render, staticRenderFns } from "./ProfessionalTable.vue?vue&type=template&id=0f304b80&"
import script from "./ProfessionalTable.vue?vue&type=script&lang=js&"
export * from "./ProfessionalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports